(function(){

  function debounce(func, timeout = 300){
      let timer;
      return (...args) => {
        clearTimeout(timer);
        timer = setTimeout(() => { func.apply(this, args); }, timeout);
      };
  }

  const frameImageCallback = function(event) {
      let $inputParent = event.target.parentElement;
      let childIndex = [...$inputParent.parentElement.children].findIndex((child) => child === $inputParent) - 1;

      
      console.log('Frame Index:', childIndex);

      const $thumbnails = document.querySelectorAll('.product__thumbs--scroller .product__thumb-item');
      switch (childIndex) {
        case -1:
          childIndex = $thumbnails.length - 1;
          break;
        case 1:
          childIndex = $thumbnails.length - 3
          break;
        case 2:
          childIndex = $thumbnails.length - 2
        default:
          break;
      }
    console.log('thumbnail Index:', childIndex);


      console.log('Click frame Index:', $thumbnails[childIndex]);

      $thumbnails[childIndex].querySelector('a').click();


      // Change to flickity interaction

      // $('.product__main-photos .slick-initialized').slick('slickGoTo', childIndex);
      // $('.product__thumbs').slick('slickGoTo', childIndex);
  }

  const start = function() {
    console.log('Start. PDF Change');

      if(!window.$) return setTimeout(start, 750);
    console.log('Past Start. PDF Change');
    
      
      $(document).on('change', 'input[name="radio-ramme"]', debounce(frameImageCallback));
  }


  start();

    
})();

window.Images = {
    removeProtocol(path) {
      return path.replace(/http(s)?:/, '');
    },
      getSizedImageUrl(src, size) {

      if (size === null) {
        return src;
      }

      if (size === 'master') {
        return this.removeProtocol(src);
      }

      const match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

       if (match) {
        const prefix = src.split(match[0]);
        const suffix = match[0];

        return this.removeProtocol(`${prefix[0]}_${size}${suffix}`);
       } else {
        return null;
       }
      }
} 

// Rammer Adjustments
class RammerOptions extends HTMLElement {
    constructor() {
      super();
      this.el = this;
      this.$container = this.el.querySelector('#rammeOption');
      this.$selection = this.el.querySelector('#rammeSelection');
      this.formId = this.dataset.formId;
      this.$form = document.getElementById(this.formId);

      this.productHandle = this.dataset.productHandle;
      this.product = (document.querySelector('[data-product-source]')) ? JSON.parse(document.querySelector('[data-product-source]').innerHTML) : null;
      this.products = [];

      this.translations = {
        soldout: this.el.dataset.translationsSoldout,
        choose_frame: this.el.dataset.translationsChooseFrame,
        only_poster: this.el.dataset.translationsOnlyPoster,
        poster_no_frame: this.el.dataset.translationsPosterNoFrame,
        frame_in_stock: this.el.dataset.translationsFrameInStock
      };

      // console.log('Ramme Options!:',{
      //   dataset: this.el.dataset,
      //   handle: this.productHandle, 
      //   product: this.product,
      // }, this.translations, this.el.dataset);

      this.assets = {
        only_poster: this.dataset.assetOnlyPoster
      }

      this.updateSelection = this.updateSelection.bind(this);
      this.frameSelectHandlers = this.frameSelectHandlers.bind(this);
      this.fetchSourceProduct();

      this.$form.addEventListener('submit', this.handleSubmit.bind(this));
      document.addEventListener('variant:change', this.onChangeCallback.bind(this))
    }

    async fetchSourceProduct() {
      const url = window.Shopify.locale == 'da' ? `/products/${this.productHandle}.js` : `/${window.Shopify.locale}/products/${this.productHandle}.js`
      const product = await fetch(url).then((res) => res.json());

      this.product = product;
      this.setCollection();
    }

    handleSubmit(event) {
      const $checkedInput = this.$container.querySelector('input:checked');

      if($checkedInput.value === 'noRamme') return;

      const items = [
        {
          id: Number($checkedInput.id),
          quantity: 1,
          properties: {},
        }
      ]

      setTimeout(() => {  
        theme.AjaxProduct.prototype.addItemFromData({ items }).then(() => {
            const event = new Event('cart:build');  
            document.dispatchEvent(event);
        })
      }, 500);
    }

    onChangeCallback(event) {
      const { detail } = event;
      const { variant, currentlySelectedValues, value, index } = detail;

      this.renderFrames();
    }

    currentRammerSet() {
      const selectedVariant = this.variant();
      const sizeIndex = [...this.product.options].reduce((key, option, index) => {
        return /size/i.test(option.name) ? `option${index+1}` : key
      }, null);

      return [
        ...this.products
      ].reduce((products, product) => {

        const variant = [...product.variants].find((variant) => variant[sizeIndex] === selectedVariant[sizeIndex]);
        
        if(!variant) return products;

        const item = {
          ...variant,
          product_featured_image: window.Images.getSizedImageUrl(product.featured_image, 'x150' )
        }

        products.push(item);

        return products;
      }, [])
    }
  
    variantId() {
      return this.$form.querySelector('[name="id"]').value;
    }

    variant() {
      return [...this.product.variants].find((variant) => variant.id == this.variantId())
    }

    async setCollection() {
      const url = window.Shopify.locale == 'da' ? `/collections/rammer?view=data` : `/${window.Shopify.locale}/collections/rammer?view=data`
      const page = await fetch(url).then((res) => res.json());

      this.products = [
        ...page.products
      ].map((product) => ({
          ...product,
          variants: [...product.variants].map((variant, index) => ({
            ...variant,
            inventory_quantity: page.inventories[product.handle][index]
          }))
      }))

      // console.log('setCollections:', { page });

      // initial render
      this.renderFrames();

      this.$container.addEventListener('change', this.updateSelection);
    }

    updateSelection() {

      const $checkedInput = this.$container.querySelector('input:checked');
      const selection = $checkedInput.value;
      const currentFrames = this.currentRammerSet();

      const variant = [...currentFrames].find(({ id }) => selection == id);

      // console.log('Update Selection', $checkedInput, { currentFrames, variant, selection });
      this.$selection.innerHTML = (variant) ? `<span>${variant.name.split("-")[0]} +${theme.Currency.formatMoney(variant.price)}</span>` : `<span>${this.translations.only_poster}</span>`
    }

    frameSelectHandlers(event) {
      const $msg = document.querySelector('.sales-points span[data-product-inventory]');
      const $icon = document.querySelector('.sales-points .sales-point .icon-and-text');
      const currentFrames = this.currentRammerSet();
      const selectedFrameVariant = event.target.value;
      const frameVariant = [...currentFrames].find((frame) => frame.id == selectedFrameVariant);


      if(!frameVariant) {
        $icon.classList.remove('inventory--low');
        $msg.textContent = this.translations.frame_in_stock;
        return;
      }

      const isSoldoutAndContinue = frameVariant.available && frameVariant.inventory_quantity < 1;

      if(frameVariant && (isSoldoutAndContinue)) {
        $icon.classList.add('inventory--low');
        $msg.textContent = this.translations.poster_no_frame;
      } else {
        $icon.classList.remove('inventory--low');
        $msg.textContent = this.translations.frame_in_stock;
      }
      // console.log('Frame select handlers changing', {
      //   el: $msg,
      //   translation: this.translations.poster_no_frame,
      // }, event.target, frameVariant, this.translations);
    }

    renderFrames() {
      const currentFrames = this.currentRammerSet();


      // console.log('renderFrames:', currentFrames);
      function renderItem(ramme) {
        const isSoldoutAndContinue = ramme.available && ramme.inventory_quantity < 1;

        return `
          <div>
            <input
              type="radio"
              name="radio-ramme"
              value="${ramme.id}" 
              ${!ramme.available ? 'disabled' : ''}             
              id="${ramme.id}"
              class="imageRadio input-hidden screen-reader-text"
            >
            <label class="rammeContainer ${(!ramme.available && !isSoldoutAndContinue) ? 'soldout-ramme': '' }" for="${ramme.id}">
              <div class="rammeImgWrapper">
                <img class="ramme" src="${ramme.product_featured_image}" alt="${ramme.name}" />
              </div>  
              ${ramme.available ? '' : ` <span class="soldoutLabel" style="display: none">UDSOLGT</span> `}
              <span class="rammeInfo" style="display: none;">
                ${ramme.name.split("-")[0]} </br>
                <span class="rammePrice product__price bf">+${theme.Currency.formatMoney(ramme.price)}</span>
              </span>
            </label>
          </div>
        `;
      }
 
      const html = [
        this.renderOnlyPoster(),
        ...currentFrames.map(renderItem)
      ].join('');

      this.$container.innerHTML = html;
      this.$container.querySelectorAll('input[ name="radio-ramme"]').forEach(($radio) => {
        $radio.addEventListener('change', this.frameSelectHandlers);
      })
      this.updateSelection();

    }

    renderOnlyPoster() {
      return `
      <div>
        <input
          type="radio"
          name="radio-ramme"
          checked
          value="noRamme"
          id="noRamme"
          class="imageRadio input-hidden screen-reader-text"
        >
        <label class="rammeContainer" for="noRamme">
          <img class="ramme" src="${this.assets.only_poster}" alt="Kun plakat" />
          <span class="rammeInfo" style="display: none;">
            ${this.translations.only_poster} </br>
            <span class="rammePrice product__price bf" style="visibility: hidden">+0 kr</span>
          </span>
        </label>
      </div>
      `
    }
}

  
customElements.define('rammer-options', RammerOptions);